export default __webpack_public_path__ + "static/media/setion03_bg_m.8544dce4.jpg";